import { getSubtotalEnabled, getSubtotalDiscountIsEmpty, getSubtotalDiscount, getShowSubtotalTax, getSubtotalTaxIsEmpty, getSubtotalValue, getSubtotalTax, } from '@getaccept/editor-lib-new/src/helpers/pricing-table/pricing-table-price-summary.helper';
import { PricingTableHelper, EPricingTableColumn } from '@getaccept/editor-lib-new';
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'PricingTablePriceSummary',
    props: {
        sectionSummary: { type: Object, default: () => ({}) },
        currencySettings: {
            type: Object,
            default: () => ({}),
        },
        isPreCalculated: { type: Boolean },
        columns: { type: Array, default: () => [] },
    },
    setup(props) {
        const getShowSubtotalDiscount = () => {
            const isSubTotalDiscountEmpty = getSubtotalDiscountIsEmpty(props.sectionSummary);
            if (!PricingTableHelper.getIsColumnEnabled(props.columns, EPricingTableColumn.Discount)) {
                return false;
            }
            if (props.isPreCalculated && !isSubTotalDiscountEmpty) {
                return true;
            }
            return !isSubTotalDiscountEmpty;
        };
        return {
            currencyFormat: PricingTableHelper.currencyFormat,
            getShowSubtotalDiscount,
            PricingTableHelper,
            getSubtotalEnabled,
            getSubtotalDiscountIsEmpty,
            getSubtotalDiscount,
            getShowSubtotalTax,
            getSubtotalTaxIsEmpty,
            getSubtotalValue,
            getSubtotalTax,
        };
    },
});
